import React, { useMemo } from 'react';
import {
  GameStoreMobileScore,
  GameStoreConsole,
  PCScore,
} from '@op/widgets/GameStorePlate';
/**
 * 这个组件可能要搬到page/widgets文件夹去给channel公用
 * @param param0
 * @returns
 */
export default function GameStoreUserScore({
  gameInfo,
  filter,
  isFeeds = false,
}: any) {
  const Element = useMemo(() => {
    const { entity_type = '' } = gameInfo;
    const map: {
      [key: string]: JSX.Element;
    } = {
      mobile: (
        <GameStoreMobileScore
          filter={filter}
          gameInfo={gameInfo}
          isFeeds={isFeeds}
        />
      ),
      pc: <PCScore filter={filter} gameInfo={gameInfo} />,
      console: <GameStoreConsole filter={filter} gameInfo={gameInfo} />,
    };

    return map[entity_type] || null;
  }, [gameInfo, filter]);


  return Element;
}
